export default __webpack_public_path__ + "static/media/741.0c9c85a9.png";